import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';

const PREFIX = 'EventTime';

export const eventTimeClasses = {
  root: `${PREFIX}-root`,
  time: `${PREFIX}-time`,
  offset: `${PREFIX}-offset`,
};

const Root = styled(Box)(() => ({
  [`&.${eventTimeClasses.root}`]: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    gap: 4,
  },
  [`.${eventTimeClasses.time}`]: {
    display: 'inline-flex',
    alignItems: 'flex-start',
  },
  [`.${eventTimeClasses.offset}`]: {
    display: 'inline-block',
    fontSize: '0.8em',
    transform: 'translateY(-0.45em)',
  },
}));

export const EventTime = ({
  startUnix = 0,
  endUnix = 0,
  startIanaTimezone = 'UTC',
  endIanaTimezone = 'UTC',
  sectorIndex,
}: {
  startUnix?: number;
  endUnix?: number;
  startIanaTimezone?: string;
  endIanaTimezone?: string;
  sectorIndex?: number;
}) => {
  const start = dayjs(startUnix).tz(startIanaTimezone);
  const end = dayjs(endUnix).tz(endIanaTimezone);

  const daysBefore = start
    ?.startOf('day')
    .diff(dayjs().tz(startIanaTimezone).startOf('day'), 'days');

  const daysAfter = end
    ?.startOf('day')
    .diff(dayjs().tz(endIanaTimezone).startOf('day'), 'days');

  const Offset = ({ value }: { value: number }) => (
    <Box component="span" className={eventTimeClasses.offset}>
      {value}
    </Box>
  );

  const TimeWithOffset = ({
    timeLabel,
    offset,
  }: {
    timeLabel: string;
    offset?: number;
  }) => (
    <Box component="span" className={eventTimeClasses.time}>
      <span>{timeLabel}</span>
      {offset ? <Offset value={offset} /> : null}
    </Box>
  );

  if (!(startUnix || endUnix)) {
    return <>NOW</>;
  }

  return (
    <Root className={eventTimeClasses.root}>
      <TimeWithOffset timeLabel={start.format('HH:mm z')} offset={daysBefore} />
      {' - '}
      <TimeWithOffset timeLabel={end.format('HH:mm z')} offset={daysAfter} />

      {sectorIndex !== undefined ? ` [${sectorIndex}]` : null}
    </Root>
  );
};
